import {ResourceSet} from "../../collection/sets/resource_set";
import {BBModel} from "../../bb_model";
import {SlotSet} from "../../collection/sets/slot_set";
import {ResourceModel} from "../core/resource";

class AdminResourceModel extends ResourceModel {

    /**
     * @param {date=} start The start date of the availability of the resource
     * @param {date=} end The end date of the availability of the resource
     * @description
     * Look up a schedule for a time range to see if this available
     *
     * @returns {string} Returns yes if availability of resource is valid
     */
    // look up a schedule for a time range to see if this available
    // currently just checks the date - but chould really check the time too
    isAvailable(start, end) {
        const str = start.format('YYYY-MM-DD') + '-' + end.format('YYYY-MM-DD');
        if (!this.availability) {
            this.availability = {};
        }

        if (this.availability[str]) {
            return this.availability[str] === 'Yes';
        }
        this.availability[str] = '-';

        if (this.$has('schedule')) {
            this.$get('schedule', {
                start_date: start.format('YYYY-MM-DD'),
                end_date: end.format('YYYY-MM-DD')
            }).then((sched) => {
                    this.availability[str] = 'No';
                    if (sched && sched.dates && sched.dates[start.format('YYYY-MM-DD')]
                        && (sched.dates[start.format('YYYY-MM-DD')] !== 'None')) {
                        return this.availability[str] = 'Yes';
                    }
                }
            );
        } else {
            this.availability[str] = 'Yes';
        }

        return this.availability[str] === 'Yes';
    }


    /**
     * @description
     * Get post data
     *
     * @returns {array} Returns data
     */
    getPostData() {
        const data = {};
        data.id = this.id;
        data.name = this.name;
        data.disabled = this.disabled;
        data.email = this.email;
        data.never_booked = this.never_booked;
        data.extra = this.extra;
        data.description = this.description;
        return data;
    }

    /**
     * @param {object} data The resources data
     * @description
     * Update the data in according of the data parameter
     *
     * @returns {array} Returns the updated array
     */
    $update(data = this.getPostData()) {
        const post_data = {...data};

        // Only send who/what/where data if any of it actually changed
        if (
            post_data.service_ids &&
            post_data.person_ids &&
            JSON.stringify(post_data.service_ids) === JSON.stringify(this._data.service_ids) &&
            JSON.stringify(post_data.person_ids) === JSON.stringify(this._data.person_ids)
        ) {
            delete post_data.service_ids;
            delete post_data.person_ids;
        }

        return this.$put('self', {}, this.jsonify(post_data)).then((res) => {
            ResourceSet.updateAll(this.self, this.company_id);
            this.constructor(res);
        });
    }

    $delete() {
        this.$flush('self');
        return this.$del('self').then((res) => {
            ResourceSet.delete(this.self, this.company_id);
        });
    }

    static $block(company, resource, data) {
        return new Promise((resolve, reject) => {
            resource.$put('block', {}, data).then((response) => {
                    SlotSet.updateAll(response.$link('slot').href, this.company_id);
                    if (response.$href('self').indexOf('bookings') > -1) {
                        const booking = new BBModel.Admin.Booking(response);
                        return resolve(booking);
                    } else {
                        const slot = new BBModel.Admin.Slot(response);
                        return resolve(slot);
                    }
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    }

    $refetch() {
        return new Promise((resolve, reject) => {
            this.$flush('self');
            this.$get('self').then((res) => {
                    this.constructor(res);
                    return resolve(this);
                }
                , err => reject(err));
        });
    }

}

export {
    AdminResourceModel
}